import useGetDashboardStatistic from './useGetDashboardStatistic'

export default useGetDashboardStatistic
